/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reference_Dataset_Legal_EntityInputs */

const en_reference_dataset_legal_entity = /** @type {(inputs: Reference_Dataset_Legal_EntityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legal entities`)
};

/**
* | output |
* | --- |
* | "Legal entities" |
*
* @param {Reference_Dataset_Legal_EntityInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const reference_dataset_legal_entity = /** @type {((inputs?: Reference_Dataset_Legal_EntityInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reference_Dataset_Legal_EntityInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_reference_dataset_legal_entity(inputs)
});